import React from "react";

import {
  InfoBoxItemDescriptionHolderHead,
  InfoBoxItemDescriptionHolderHeadButton,
  InfoBoxItemDescriptionHolderHeadButtons,
} from "../SpecialInfoBoxItem";
import ShareLinkButton from "../ShareLinkButton";
import BookmarkIcon from "../BookmarkIcon";
import urlPatterns from "../../../urls";
import { trackingEvents, useTrackEvent } from "../../../helpers/Analytics";
import { GetWine_wine } from "../../../types/__generated__/GetWine";

interface ShareAndBookmarkProps {
  isInBoxAndCartTray?: boolean;
  isWineDetailsPage?: boolean;
  handleWineListsPanelChange: Function;
  wine: GetWine_wine | null | undefined;
}

const ShareAndBookmark = ({
  wine,
  isInBoxAndCartTray = false,
  handleWineListsPanelChange,
  isWineDetailsPage = false,
}: ShareAndBookmarkProps) => {
  const trackEvent = useTrackEvent();

  const { product, isBookmarked } = wine || {};
  const { slug } = product || {};
  const wineUrl = `${import.meta.env.REACT_APP_BASE_URL}${urlPatterns.WINE_DETAILS(slug)}`;

  // Tracking event to trigger on share button click
  const shareButtonClickTrack = () => {
    trackEvent(trackingEvents.TRACKING_EVENT_CLICKED_WINE_SHARE_BUTTON, {
      wine_url: wineUrl,
    });
  };

  // Tracking event to trigger on copy link action
  const copyLinkClickTrack = () => {
    trackEvent(trackingEvents.TRACKING_EVENT_COPIED_WINE_SHARE_LINK, {
      wine_url: wineUrl,
    });
  };

  return (
    // @ts-ignore
    <InfoBoxItemDescriptionHolderHead noMarginBottom>
      <InfoBoxItemDescriptionHolderHeadButtons>
        <ShareLinkButton
          isInBoxAndCartTray={isInBoxAndCartTray}
          urlLink={wineUrl}
          shareButtonClickTrack={shareButtonClickTrack}
          copyLinkClickTrack={copyLinkClickTrack}
        />
        {!isWineDetailsPage && (
          <InfoBoxItemDescriptionHolderHeadButton onClick={() => handleWineListsPanelChange()}>
            <BookmarkIcon isBookmarked={isBookmarked} />
          </InfoBoxItemDescriptionHolderHeadButton>
        )}
      </InfoBoxItemDescriptionHolderHeadButtons>
    </InfoBoxItemDescriptionHolderHead>
  );
};

export default ShareAndBookmark;
